import { createApp } from 'vue'
import AccountRoot from './Root.vue'
import router from './router'
//import pinia
import { setupStore } from "../../utils/stores/index";
import { VueCookieNext } from 'vue-cookie-next'
// import the package
import VueAwesomePaginate from "vue-awesome-paginate";
// import the necessary css file
import "vue-awesome-paginate/dist/style.css";
import { defineRule } from 'vee-validate'

	defineRule('confirmed', (value, [target]) => {
		if (value === target) {
			return true
		}

		return 'The passwords don\'t match. Please try again'
	})
	defineRule('required', (value) => {
		if (!value || !value.length) {
			return 'Uh-oh, the password confirmation field is empty - please try re-entering'
		}

		return true
	})
  defineRule('confirmed_email', (value, [target]) => {
		if (value === target) {
			return true
		}

		return 'Oops, please check if your email is correct.'
	})
	defineRule('required_email', (value) => {
		if (!value || !value.length) {
			return 'Uh-oh, the email confirmation field is empty - please try re-entering'
		} // if the field is not a valid email
    else if (!/^(?!.*\.{2})\s*(?!\.)(?!.*@.*@)([!#$%&'*+\-\/=?^`{|}~\w.]{0,62})[a-zA-Z0-9!#$%&'*+\-_\/=?^`{|}~]@((?:[a-zA-Z-]?)[a-zA-Z0-9-]+\.)+([a-zA-Z]{2,})\s*$/i.test(value))
      return "Hmm… something's wrong. Please check your confirmation email address is in this format: yourname@example.com"

		return true
	})
// stripe
import '@stripe/stripe-js'
var stripe_key =
	process.env.NODE_ENV === 'production' ? process.env.STRIPE_PUBLISHABLE_KEY : 'pk_test_Uk8G5S4to7ggk4I7BAYVxDHV'
import { loadStripe } from '@stripe/stripe-js'


import('../../utils/store').then(function (store) {
	const app = createApp(AccountRoot)
	loadStripe(stripe_key).then((stripe) => {
		app.config.globalProperties.$stripe = stripe
	})
  setupStore(app)
	app.use(store.default)
	app.use(router)
	app.use(VueCookieNext)
  app.use(VueAwesomePaginate)
	app.mount('#account')
})
